export default __webpack_public_path__ + "assets/images/aa53005fc3e8da4171164a84fe9b8a53.svg";